import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AppRoutingModule } from './app-routing.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";

import { AppComponent } from './app.component';
import { DocumentoVistaComponent } from './components/documento-vista/documento-vista.component';
import { FirmantesComponent } from './components/firmantes/firmantes.component';
import { FirmarComponent } from './components/firmar/firmar.component';
import { RechazarComponent } from './components/rechazar/rechazar.component';
import { BandejaPrincipalComponent } from './pages/bandeja-principal/bandeja-principal.component';
import { ResultadoComponent } from './pages/resultado/resultado.component';
import { BotonAccionComponent } from './components/boton-accion/boton-accion.component';

import { AutenticacionService } from './services/autenticacion.service';
import { GatewayService } from './services/gateway.service';
import { UbicacionService } from './services/ubicacion.service';
import { ValidadoresService } from './services/validadores.service';
import { LoaderService } from './services/loader.service';

import { JwtInterceptor } from "./interceptors/jwt.interceptor";
import { LoaderComponent } from './components/loader/loader.component';
import { LoaderInterceptorService } from './interceptors/loader.interceptor';
import { NotFoundComponent } from './pages/not-found/not-found.component';

@NgModule({
  declarations: [
    AppComponent,
    DocumentoVistaComponent,
    FirmantesComponent,
    FirmarComponent,
    RechazarComponent,
    BandejaPrincipalComponent,
    ResultadoComponent,
    BotonAccionComponent,
    LoaderComponent,
    NotFoundComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    PdfViewerModule,
    BrowserAnimationsModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    MatGridListModule,
    MatTooltipModule,
    MatDialogModule,
    MatInputModule,
    MatFormFieldModule,
    MatToolbarModule,
    MatCardModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MatProgressSpinnerModule
  ],
  providers: [
    AutenticacionService,
    GatewayService,
    UbicacionService,
    ValidadoresService,
    LoaderService,
    { provide: LOCALE_ID, useValue: 'es-CL' },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptorService, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
